import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-navy-950 px-5 pb-28 pt-12 md:pb-12" data-id="element-157" data-mp="3gf93arl2hy6u">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-158" data-mp="3ggtxuh7dth4p">
        <Logo tone="dark" data-id="element-159" data-mp="32ovzn1f7l5nb" />
        <p className="mt-4 text-sm text-white/70" data-id="element-160" data-mp="32pp3nums9h1r">© 2026 · Dr. Michael Carter – Implant Risk Radar™. All rights reserved.</p>
        <p className="mt-6 text-xs leading-relaxed text-white/55" data-id="element-161" data-mp="3uf0nja26gata">
          <strong className="text-white/70" data-id="element-162" data-mp="3uftm3nqzfu0c">Educational Disclaimer:</strong> Implant Risk Radar™ is an educational
          reference product and is not a substitute for formal clinical education, hands-on surgical training,
          professional judgment, diagnosis, treatment planning, or appropriate specialist consultation. Clinical
          decisions should always be based on the individual patient, applicable standards of care, and the clinician's
          qualifications and scope of practice.
        </p>
      </div>
    </footer>;
}